/*
|-------------------------------------------------------------------------------
| VUEX index.js — assembles the store from feature modules
|-------------------------------------------------------------------------------
*/
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import patient from './patient'
import ui from './ui'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [],
  modules: {
    auth,
    patient,
    ui,
  },
})

export default store
